<template>
  <div
    class="services-test-area bg-mg ptb-100 position-relative overflow-hidden"
    :style="{ backgroundImage: 'url(' + bgImage + ')' }"
  >
    <div class="container mw-1356">
      <div
        class="services-test-content"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="100"
      >
        <span class="top-title">التجربة</span>
        <h2 class="text-white">
          ابدأ الآن. لا تتردد في تجربة خدمتنا
        </h2>
        <p class="text-silver">
          حساب تجريبي. احصل على وصول كامل لجميع القنوات ومكتبة الأفلام والمسلسلات
        </p>
        <div class="d-flex align-items-center amount">
          <div class="flex-shrink-0">
            <i class="flaticon-tv"></i>
          </div>
          <div class="flex-grow-1 ms-3">
            <h2>$ 14.99<sub>/ شهرياً</sub></h2>
            <span>تجربة لمدة شهر واحد، الرضا مضمون أو استرداد أموالك.</span>
          </div>
        </div>
        <div class="d-flex gap-2 flex-wrap">
          <RouterLink to="/services" class="btn bg-grey-teal">
            <span class="border-style">جرب خدمتنا الآن</span>
          </RouterLink>
          <a href="tel:3212344567" class="btn bg-transparent">
            <span class="border-style">
              <span>اتصل: 3212344567+</span> لأي استفسار
            </span>
          </a>
        </div>
      </div>
    </div>

    <img src="@/assets/images/shape-9.png" class="shape shape-9" alt="shape" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "TestOurService",
  setup() {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const bgImage = require("@/assets/images/services-test-bg-2.jpg");

    return {
      bgImage,
    };
  },
});
</script>